// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3AuHg","amount":"Amount_amount__KEZtS","tip":"Amount_tip__34flu","tipHeader":"Amount_tipHeader__1sSuX","tipsWrap":"Amount_tipsWrap__3kEFG"};